import { VoiceCallModel } from 'flow-schema';

export const VoiceCallModelDescriptions: Record<VoiceCallModel, string> = {
  [VoiceCallModel.gpt_4o]: 'GPT-4o (deprecated, use gpt-4o-2024-11-20 instead)',
  [VoiceCallModel.gpt_4o_mini]: 'GPT-4o-mini',
  [VoiceCallModel.gpt_4o_2024_11_20]: 'GPT-4o-2024-11-20',
  [VoiceCallModel.gpt_4o_realtime_cluster]: 'GPT-4o Realtime (Production)',
  [VoiceCallModel.gpt_4o_realtime_preview]: 'GPT-4o Realtime (Preview)',
  [VoiceCallModel.gpt_4o_mini_realtime_preview]: 'GPT-4o-mini Realtime (Preview)',
  [VoiceCallModel.gpt_4_1]: 'GPT-4.1',
  [VoiceCallModel.gpt_4_1_mini]: 'GPT-4.1-mini',
  [VoiceCallModel.claude_3_5_sonnet]: 'Claude 3.5 Sonnet',
  [VoiceCallModel.claude_3_7_sonnet]: 'Claude 3.7 Sonnet',
  [VoiceCallModel.claude_opus_4]: 'Claude Opus 4',
  [VoiceCallModel.claude_opus_4_5]: 'Claude Opus 4.5',
  [VoiceCallModel.claude_opus_4_6]: 'Claude Opus 4.6',
  [VoiceCallModel.claude_sonnet_4]: 'Claude Sonnet 4',
  [VoiceCallModel.claude_sonnet_4_5]: 'Claude Sonnet 4.5',
  [VoiceCallModel.claude_sonnet_4_6]: 'Claude Sonnet 4.6',
  [VoiceCallModel.claude_haiku_4_5]: 'Claude Haiku 4.5',
  [VoiceCallModel.notable_gpt_4o]: 'GPT-4o (Notable)',
  [VoiceCallModel.gpt_5]: 'GPT-5',
  [VoiceCallModel.gpt_5_mini]: 'GPT-5-mini',
  [VoiceCallModel.gpt_5_nano]: 'GPT-5-nano',
  [VoiceCallModel.gpt_5_chat]: 'GPT-5-chat',
  [VoiceCallModel.gpt_5_1]: 'GPT-5.1',
  [VoiceCallModel.gpt_5_1_chat]: 'GPT-5.1-chat',
  [VoiceCallModel.gpt_5_2]: 'GPT-5.2',
  [VoiceCallModel.gpt_5_2_chat]: 'GPT-5.2-chat',
};
